import { create } from "zustand";
import { SESSION_STORAGE_KEY } from "@/config";
import type { AppRole } from "@/lib/auth/roles";

export type RestaurantMembership = {
  id: string;
  restaurantId: string;
  role: AppRole;
  restaurantName: string | null;
  slug: string | null;
  logoUrl?: string | null;
};

type RestaurantStore = {
  activeRestaurantId: string | null;
  activeRole: AppRole | null;
  activeSlug: string | null;
  memberships: RestaurantMembership[];
  /** Selected membership row id (user_roles.id) */
  activeMembershipId: string | null;
  setRestaurantState: (payload: {
    activeRestaurantId: string;
    activeRole: AppRole;
    activeSlug: string | null;
    activeMembershipId: string;
    memberships: RestaurantMembership[];
  }) => void;
  clearRestaurantState: () => void;
};

const initialState = {
  activeRestaurantId: null,
  activeRole: null,
  activeSlug: null,
  memberships: [] as RestaurantMembership[],
  activeMembershipId: null,
};

export const useRestaurantStore = create<RestaurantStore>((set) => ({
  ...initialState,
  setRestaurantState: (payload) => {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(SESSION_STORAGE_KEY, payload.activeRestaurantId);
    }
    set({
      activeRestaurantId: payload.activeRestaurantId,
      activeRole: payload.activeRole,
      activeSlug: payload.activeSlug,
      activeMembershipId: payload.activeMembershipId,
      memberships: payload.memberships,
    });
  },
  clearRestaurantState: () => {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
    set({ ...initialState });
  },
}));
